import { COLOR as fColors } from 'f-web/src/styles'

export const colors = {
  ...fColors,
  background: '#231F20',
  backgroundText: 'white',
  primary: '#D0021B',
  secondary: '#9A1C02',
}
